import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type IconName =
  | 'arrow-left'
  | 'arrow-up'
  | 'graduation-cap'
  | 'file-text'
  | 'check-circle'
  | 'clock'
  | 'map-pin'
  | 'credit-card'
  | 'download'
  | 'calendar'
  | 'info'
  | 'alert-circle'
  | 'chevron-right'
  | 'chevron-left'
  | 'chevron-up'
  | 'chevron-down'
  | 'user'
  | 'users'
  | 'mail'
  | 'phone'
  | 'building'
  | 'briefcase'
  | 'document'
  | 'eye'
  | 'eye-off'
  | 'check'
  | 'x'
  | 'menu'
  | 'search'
  | 'settings'
  | 'message-square'
  | 'dollar-sign'
  | 'layout-dashboard'
  | 'user-check'
  | 'plus'
  | 'edit'
  | 'filter'
  | 'log-out'
  | 'bell'
  | 'trash'
  | 'upload'
  | 'clipboard-list'
  | 'shield'
  | 'file-check'
  | 'file'
  | 'hash'
  | 'alert-triangle'
  | 'toggle-left'
  | 'toggle-right'
  | 'inbox'
  | 'smartphone'
  | 'copy'
  | 'key'
  | 'activity'
  | 'heart'
  | 'tag'
  | 'refresh-cw'
  | 'loader'
  | 'external-link'
  | 'door-open'
  | 'list-checks'
  ;

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [CommonModule],
  template: `
    <svg
      [attr.class]="className"
      [attr.width]="width"
      [attr.height]="height"
      [attr.viewBox]="viewBox"
      [attr.fill]="fill"
      [attr.stroke]="stroke"
      [attr.stroke-width]="strokeWidth"
      [attr.stroke-linecap]="strokeLinecap"
      [attr.stroke-linejoin]="strokeLinejoin"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ng-container [ngSwitch]="name">
        <!-- Arrow Left -->
        <g *ngSwitchCase="'arrow-left'">
          <path d="m12 19-7-7 7-7" />
          <path d="M19 12H5" />
        </g>

        <!-- Arrow Up -->
        <g *ngSwitchCase="'arrow-up'">
          <path d="m12 5 7 7-7 7" />
          <path d="M5 12h14" />
        </g>

        <!-- Graduation Cap -->
        <g *ngSwitchCase="'graduation-cap'">
          <path d="m22 10-10-5-10 5 10 5 10-5z" />
          <path d="M6 12v5c3 3 9 3 12 0v-5" />
        </g>

        <!-- File Text -->
        <g *ngSwitchCase="'file-text'">
          <path
            d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
          />
          <path d="M14 2v4a2 2 0 0 0 2 2h4" />
          <path d="M10 9H8" />
          <path d="M16 13H8" />
          <path d="M16 17H8" />
        </g>

        <!-- Check Circle -->
        <g *ngSwitchCase="'check-circle'">
          <circle cx="12" cy="12" r="10" />
          <path d="m9 12 2 2 4-4" />
        </g>

        <!-- Clock -->
        <g *ngSwitchCase="'clock'">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </g>

        <!-- Map Pin -->
        <g *ngSwitchCase="'map-pin'">
          <path
            d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"
          />
          <circle cx="12" cy="10" r="3" />
        </g>

        <!-- Credit Card -->
        <g *ngSwitchCase="'credit-card'">
          <rect width="20" height="14" x="2" y="5" rx="2" />
          <line x1="2" x2="22" y1="10" y2="10" />
        </g>

        <!-- Download -->
        <g *ngSwitchCase="'download'">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" x2="12" y1="15" y2="3" />
        </g>

        <!-- Calendar -->
        <g *ngSwitchCase="'calendar'">
          <path d="M8 2v4" />
          <path d="M16 2v4" />
          <rect width="18" height="18" x="3" y="4" rx="2" />
          <path d="M3 10h18" />
        </g>

        <!-- Info -->
        <g *ngSwitchCase="'info'">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4" />
          <path d="M12 8h.01" />
        </g>

        <!-- Alert Circle -->
        <g *ngSwitchCase="'alert-circle'">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" x2="12" y1="8" y2="12" />
          <line x1="12" x2="12.01" y1="16" y2="16" />
        </g>

        <!-- Chevron Right -->
        <g *ngSwitchCase="'chevron-right'">
          <path d="m9 18 6-6-6-6" />
        </g>

        <!-- Chevron Left -->
        <g *ngSwitchCase="'chevron-left'">
          <path d="m15 18-6-6 6-6" />
        </g>

        <!-- Chevron Down -->
        <g *ngSwitchCase="'chevron-down'">
          <polyline points="6 9 12 15 18 9" />
        </g>

        <!-- chevron-up -->
        <g *ngSwitchCase="'chevron-up'">
          <polyline points="18 15 12 9 6 15" />
        </g>

        <!-- User -->
        <g *ngSwitchCase="'user'">
          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </g>

        <!-- Users -->
        <g *ngSwitchCase="'users'">
          <path
            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </g>

        <!-- Mail -->
        <g *ngSwitchCase="'mail'">
          <rect width="20" height="16" x="2" y="4" rx="2" />
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
        </g>

        <!-- Phone -->
        <g *ngSwitchCase="'phone'">
          <path
            d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
          />
        </g>

        <!-- Building -->
        <g *ngSwitchCase="'building'">
          <rect width="16" height="20" x="4" y="2" rx="2" ry="2" />
          <path d="M9 22v-4h6v4" />
          <path d="M8 6h.01" />
          <path d="M16 6h.01" />
          <path d="M12 6h.01" />
          <path d="M12 10h.01" />
          <path d="M12 14h.01" />
          <path d="M16 10h.01" />
          <path d="M16 14h.01" />
          <path d="M8 10h.01" />
          <path d="M8 14h.01" />
        </g>

        <!-- Briefcase -->
        <g *ngSwitchCase="'briefcase'">
          <rect width="20" height="14" x="2" y="7" rx="2" ry="2" />
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </g>

        <!-- Document -->
        <g *ngSwitchCase="'document'">
          <path
            d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
          />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </g>

        <!-- Eye -->
        <g *ngSwitchCase="'eye'">
          <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
          <circle cx="12" cy="12" r="3" />
        </g>

        <!-- Eye Off -->
        <g *ngSwitchCase="'eye-off'">
          <path
            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
          />
        </g>

        <!-- Check -->
        <g *ngSwitchCase="'check'">
          <path d="M20 6 9 17l-5-5" />
        </g>

        <!-- X -->
        <g *ngSwitchCase="'x'">
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </g>

        <!-- Menu -->
        <g *ngSwitchCase="'menu'">
          <line x1="4" x2="20" y1="12" y2="12" />
          <line x1="4" x2="20" y1="6" y2="6" />
          <line x1="4" x2="20" y1="18" y2="18" />
        </g>

        <!-- Search -->
        <g *ngSwitchCase="'search'">
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.3-4.3" />
        </g>

        <!-- Settings -->
        <g *ngSwitchCase="'settings'">
          <circle cx="12" cy="12" r="10" />
          <circle cx="12" cy="12" r="4" />
          <path
            d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.09a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h.09a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0->0-1.51 1z"
          />
        </g>

        <!-- message-square -->
        <g *ngSwitchCase="'message-square'">
          <path
            d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
          />
        </g>

        <!-- dollar-sign -->
        <g *ngSwitchCase="'dollar-sign'">
          <path d="M12 1v22" />
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </g>

        <!-- bell -->
        <g *ngSwitchCase="'bell'">
          <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </g>

        <!-- layout-dashboard -->
        <g *ngSwitchCase="'layout-dashboard'">
          <path
            d="M9.579 3H4.125a1.125 1.125 0 0 0-1.125 1.125v6.724a1.125 1.125 0 0 0 1.125 1.125h5.455a1.125 1.125 0 0 0 1.125-1.125V4.125A1.125 1.125 0 0 0 9.579 3"
          />
          <path
            d="M19.853 3h-5.455a1.125 1.125 0 0 0-1.125 1.125v1.602a1.125 1.125 0 0 0 1.125 1.125h5.455a1.125 1.125 0 0 0 1.125-1.125V4.125A1.125 1.125 0 0 0 19.853 3"
          />
          <path
            d="M19.853 9.421h-5.455a1.125 1.125 0 0 0-1.125 1.125v9.307a1.125 1.125 0 0 0 1.125 1.125h5.455a1.125 1.125 0 0 0 1.125-1.125v-9.307a1.125 1.125 0 0 0-1.125-1.125"
          />
          <path
            d="M9.579 14.557H4.125A1.125 1.125 0 0 0 3 15.682v4.171a1.125 1.125 0 0 0 1.125 1.125h5.455a1.125 1.125 0 0 0 1.125-1.125v-4.171a1.125 1.125 0 0 0-1.125-1.125"
          />
        </g>

        <!-- user-check -->
        <g *ngSwitchCase="'user-check'">
          <path d="M2 21a8 8 0 0 1 13.292-6" />
          <circle cx="10" cy="8" r="5" />
          <path d="m16 19 2 2 4-4" />
        </g>

        <!-- plus -->
        <g *ngSwitchCase="'plus'">
          <line x1="12" y1="5" x2="12" y2="19" />
          <line x1="5" y1="12" x2="19" y2="12" />
        </g>

        <!-- Edit -->
        <g *ngSwitchCase="'edit'">
          <path
            d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
          />
          <path d="m18.5 2.5 3 3L12 15l-4 1 1-4L18.5 2.5z" />
        </g>

        <!-- filter -->
        <g *ngSwitchCase="'filter'">
          <path d="M3 4h18M6 12h12M10 20h4" />
        </g>

        <!-- log-out -->
        <g *ngSwitchCase="'log-out'">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 21 12 16 7" />
          <line x1="21" x2="9" y1="12" y2="12" />
        </g>

        <!-- trash -->
        <g *ngSwitchCase="'trash'">
          <polyline points="3 6 5 6 21 6" />
          <path
            d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
          />
          <line x1="10" x2="10" y1="11" y2="17" />
          <line x1="14" x2="14" y1="11" y2="17" />
        </g>

        <!-- upload -->
        <g *ngSwitchCase="'upload'">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="17 8 12 3 7 8" />
          <line x1="12" x2="12" y1="3" y2="15" />
        </g>

        <!-- clipboard-list -->
        <g *ngSwitchCase="'clipboard-list'">
          <path
            d="M9 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-2"
          />
          <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
          <line x1="9" x2="9.01" y1="10" y2="10" />
          <line x1="13" x2="15" y1="10" y2="10" />
          <line x1="9" x2="9.01" y1="14" y2="14" />
          <line x1="13" x2="15" y1="14" y2="14" />
        </g>

        <!-- shield -->
        <g *ngSwitchCase="'shield'">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </g>

        <!-- file-check -->
        <g *ngSwitchCase="'file-check'">
          <path
            d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
          />
          <polyline points="14 2 14 8 20 8" />
          <path d="m9 15 2 2 4-4" />
        </g>

        <!-- hash -->
        <g *ngSwitchCase="'hash'">
          <line x1="4" x2="20" y1="9" y2="9" />
          <line x1="4" x2="20" y1="15" y2="15" />
          <line x1="10" x2="8" y1="3" y2="21" />
          <line x1="16" x2="14" y1="3" y2="21" />
        </g>

        <!-- alert-triangle -->
        <g *ngSwitchCase="'alert-triangle'">
          <path
            d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
          />
          <line x1="12" x2="12" y1="9" y2="13" />
          <line x1="12" x2="12.01" y1="17" y2="17" />
        </g>

        <!-- toggle-left -->
        <g *ngSwitchCase="'toggle-left'">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 11 12 16 7" />
          <line x1="11" x2="21" y1="12" y2="12" />
        </g>

        <!-- toggle-right -->
        <g *ngSwitchCase="'toggle-right'">
          <path d="M15 21h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-4" />
          <polyline points="8 17 13 12 8 7" />
          <line x1="13" x2="3" y1="12" y2="12" />
        </g>

        <!-- toggle-left -->
        <g *ngSwitchCase="'toggle-left'">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 11 12 16 7" />
          <line x1="11" x2="21" y1="12" y2="12" />
        </g>

        <!-- inbox -->
        <g *ngSwitchCase="'inbox'">
          <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
          <path
            d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
          />
        </g>

        <!-- smartphone -->
        <g *ngSwitchCase="'smartphone'">
          <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
          <line x1="12" x2="12.01" y1="18" y2="18" />
        </g>

        <!-- copy -->
        <g *ngSwitchCase="'copy'">
          <rect width="16" height="16" x="8" y="8" rx="2" ry="2" />
          <path d="M16 8v8H8V8h8z" />
        </g>

        <!-- key -->
        <g *ngSwitchCase="'key'">
          <path
            d="
      M15 3
      c-3.3 0-6 2.7-6 6
      0 .45.075.9.15 1.35
      L3 16.5
      v4.5
      h3.75
      v-2.25
      h2.25
      v-2.25
      h2.25
      v-2.25
      h0.825
      c0.825.45 1.875.75 2.925.75
      3.3 0 6-2.7 6-6
      s-2.7-6-6-6
      z
    "
          />
          <circle cx="16.5" cy="7.5" r="1.5" />
        </g>

        <!-- activity -->
        <g *ngSwitchCase="'activity'">
          <polyline points="22 12 18 12 15 3 9 21 6 12 2 12" />
        </g>

        <!-- save -->
        <g *ngSwitchCase="'save'">
          <path
            d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
          />
          <polyline points="17 21 17 13 7 13 7 21" />
          <polyline points="7 3 7 8 15 8" />
        </g>

        <!-- heart -->
        <g *ngSwitchCase="'heart'">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </g>

        <!-- tag -->
        <g *ngSwitchCase="'tag'">
          <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5z" />
          <line x1="16" x2="16" y1="16" y2="16" />
          <line x1="8" x2="8" y1="8" y2="8" />
        </g>

        <!-- file -->
        <g *ngSwitchCase="'file'">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </g>

        <!-- refresh-cw -->
        <g *ngSwitchCase="'refresh-cw'">
          <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
          <path d="M3 3v5h5" />
        </g>

        <!-- loader -->
        <g *ngSwitchCase="'loader'">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </g>

        <!-- external-link -->
        <g *ngSwitchCase="'external-link'">
              <path
                d="M14 2a1 1 0 0 0-1 1.15A1.05 1.05 0 0 0 14.05 4h4.55L12.35 10.25a1 1 0 0 0-.1 1.4.9.9 0 0 0 .75.35 1 1 0 0 0 .7-.3L20 5.4v4.55a1.05 1.05 0 0 0 .85 1.05A1 1 0 0 0 22 10V3a1 1 0 0 0-1-1Z"
                fill="none"
              />
              <path
                d="M20.85 15a1.05 1.05 0 0 0-.85 1.05V20H4V4h4a1 1 0 0 0 1-1.15A1.05 1.05 0 0 0 7.95 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-5a1 1 0 0 0-1.15-1"
                fill="none"
              />
        </g>

        <!-- door-open -->
        <g *ngSwitchCase="'door-open'">
          <path
            d="M5 2h11a3 3 0 0 1 3 3v14a1 1 0 0 1-1 1h-3"
            fill="none"
          />
          <path
            d="m5 2 7.588 1.518A3 3 0 0 1 15 6.459V20.78a1 1 0 0 1-1.196.98l-7.196-1.438A2 2 0 0 1 5 18.36zm7 10v2"
            fill="none"
          />
        </g>

        <!-- list-checks -->
        <g *ngSwitchCase="'list-checks'">
            <line x1="10" y1="6" x2="21" y2="6" />
            <line x1="10" y1="12" x2="21" y2="12" />
            <line x1="10" y1="18" x2="21" y2="18" />
            <polyline points="3 6 4 7 6 5" />
            <polyline points="3 12 4 13 6 11" />
            <polyline points="3 18 4 19 6 17" />
        </g>

        <!-- Default Icon "?" with circle -->
        <g *ngSwitchDefault>
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 1 1 5.83 1c0 2-3 3-3 3" />
          <line x1="12" x2="12.01" y1="17" y2="17" />
        </g>
      </ng-container>
    </svg>
  `,
})
export class IconComponent {
  @Input() name: IconName = 'file-text';
  @Input() className: string = 'w-5 h-5';
  @Input() width: string = '24';
  @Input() height: string = '24';
  @Input() viewBox: string = '0 0 24 24';
  @Input() fill: string = 'none';
  @Input() stroke: string = 'currentColor';
  @Input() strokeWidth: string = '2';
  @Input() strokeLinecap: string = 'round';
  @Input() strokeLinejoin: string = 'round';
}
